import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IngredientCard } from '@app/mpp/model/ingredient-card-model';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-ingredients-mobile-container',
  templateUrl: './ingredients-mobile.component.html',
  styleUrls: ['./ingredients-mobile.component.scss'],
})
export class IngredientsMobileComponent {
  @Input() ingredients: IngredientCard[];
  @Input() selectedIngredient: string;
  @Input() searchKey: string;
  @Input() platform: PlatformEnum;

  @Output() ellipsisSelectionEvent = new EventEmitter<string>();
  @Output() addIngredientsEvent = new EventEmitter<void>();
  @Output() dragDropEvent = new EventEmitter<string>();

  platformRef = PlatformEnum;
  constructor() {}

  onAddIngredients() {
    this.addIngredientsEvent.emit();
  }
}
